<template>
  <div class="home">
    <div class="home__left">
      <div>
        <h1>
          <div>{{'homeTitle1' | localize}}&nbsp;</div>
          <div>{{'homeTitle2' | localize}}&nbsp;</div>
          <div v-if="locale == 'ru'">{{'homeTitle3' | localize}}&nbsp;</div>
        </h1>

        <p>
          {{'aboutUs' | localize}}
          <b>{{'niceToMeet' | localize}}</b>
          {{'itsMe' | localize}}
        </p>
        <br />
        <a href="#contacts" class="btn-primary margin-5" v-smooth-scroll>{{'writeUs' | localize}}</a>
        <a
          :href="'projectsLink' | localize"
          class="btn-primary margin-5"
        >{{'ourProjects' | localize}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {},
  data: () => ({
    locale: "",
  }),
  mounted() {
    this.locale = localStorage.getItem("locale");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.home {
  position: relative;
  width: 100vw;
  height: 75vh;
  min-height: 950px;
  overflow: hidden;
  background: url(/img/home/page1.svg) 50% 50% no-repeat;

  @media (min-width: 990px) and (max-width: 1199px) {
    background-size: cover;
    min-height: 765px;
    max-height: 765px;
  }

  &__left {
    @extend .flex__center__center;
    flex-direction: column;
    position: absolute;
    height: 100%;
    width: 525px;

    @media (min-width: 990px) and (max-width: 1199px) {
      width: 435px;
    }

    right: 50%;
    bottom: 0;
  }
}
</style>
